import { useMutation } from '@tanstack/react-query';

import { CreateUpdateUserRequest, getSMPBackendAPIAdmin } from '@/proxy';

function createUser(userRequest: CreateUpdateUserRequest) {
  return getSMPBackendAPIAdmin().usersControllerCreateV1(userRequest);
}

export function useCreateUser() {
  return useMutation({ mutationFn: createUser });
}
